import { RouterProvider as TsrProvider } from '@tanstack/react-router';
import React from 'react';
import { router as TsrRouter } from './Router';
import { useAppStore } from './inertia/AppStore';

const LazyTsrDevtools = React.lazy(() =>
  import('@tanstack/react-router-devtools').then((res) => ({
    default: res.TanStackRouterDevtools,
  }))
);

const TsrDevtools = () => {
  const showDevTools = useAppStore((state) => state.showTsrDevTools);

  if (showDevTools || window.location.hostname === 'localhost')
    return (
      <React.Suspense fallback={null}>
        <LazyTsrDevtools router={TsrRouter} />
      </React.Suspense>
    );

  return null;
};

export const TsRouterProvider = (
  // infer props from TsrProvider
  props: Omit<React.ComponentProps<typeof TsrProvider>, 'router'>
) => {
  return (
    <>
      <TsrProvider router={TsrRouter} {...props} />
      <TsrDevtools />
    </>
  );
};
